// PQT Report (Statement of Work - PQT Structure)
export const FETCH_PQT_ELEMENTS = '@@projectPqtReports/fetch-pqt-elements';
export const FETCH_PQT_ELEMENTS_SUCCESS = '@@projectPqtReports/fetch-pqt-elements-success';
export const FETCH_PQT_ELEMENTS_FAILURE = '@@projectPqtReports/fetch-pqt-elements-failure';

export const FETCH_PROJECT_PQT_REPORT = '@@projectPqtReports/fetch-project-pqt-report';
export const FETCH_PROJECT_PQT_REPORT_SUCCESS = '@@projectPqtReports/fetch-project-pqt-report-success';
export const FETCH_PROJECT_PQT_REPORT_FAILURE = '@@projectPqtReports/fetch-project-pqt-report-failure';

export const UPDATE_PROJECT_PQT_REPORT = '@@projectPqtReports/update-project-pqt-report';
export const UPDATE_PROJECT_PQT_REPORT_SUCCESS = '@@projectPqtReports/update-project-pqt-report-success';
export const UPDATE_PROJECT_PQT_REPORT_FAILURE = '@@projectPqtReports/update-project-pqt-report-failure';

export const CREATE_PROJECT_PQT_REPORT = '@@projectPqtReports/create-project-pqt-report';
export const CREATE_PROJECT_PQT_REPORT_SUCCESS = '@@projectPqtReports/create-project-pqt-report-success';
export const CREATE_PROJECT_PQT_REPORT_FAILURE = '@@projectPqtReports/create-project-pqt-report-failure';

export const CREATE_PQT_ELEMENT = '@@projectPqtReports/create-pqt-element';
export const CREATE_PQT_ELEMENT_SUCCESS = '@@projectPqtReports/create-pqt-element-success';
export const CREATE_PQT_ELEMENT_FAILURE = '@@projectPqtReports/create-pqt-element-failure';

// DSR Log PQT (actual values per log date / shift)
export const FETCH_DSR_LOG_PQT = '@@projectPqtReports/fetch-dsr-log-pqt';
export const FETCH_DSR_LOG_PQT_SUCCESS = '@@projectPqtReports/fetch-dsr-log-pqt-success';
export const FETCH_DSR_LOG_PQT_FAILURE = '@@projectPqtReports/fetch-dsr-log-pqt-failure';
export const UPDATE_DSR_LOG_PQT = '@@projectPqtReports/update-dsr-log-pqt';
export const UPDATE_DSR_LOG_PQT_SUCCESS = '@@projectPqtReports/update-dsr-log-pqt-success';
export const UPDATE_DSR_LOG_PQT_FAILURE = '@@projectPqtReports/update-dsr-log-pqt-failure';
